import { render, staticRenderFns } from "./Max.vue?vue&type=template&id=639e3d04"
import script from "./Max.vue?vue&type=script&lang=js"
export * from "./Max.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports